import React, { FC, useCallback } from 'react'
import { Grid, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { makeStyles } from '@mui/styles'
import { Theme } from '@mui/material/styles'
import clsx from 'clsx'
import { ClientAccounts } from './ClientAccounts'
import { SparlingAccounts } from './SparlingAccounts'

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    backGroundColor: 'transparent',
    '& .MuiBox-root': {
      padding: 0,
    },
    '& .Mui-selected': {
      opacity: 1,
      color: `#fff !important`,
    },
  },
  tabPanel: {
    width: '100%',
    backgroundColor: 'transparent',
    '& > div': {
      width: '100%',
    },
  },
  buttonsWrap: {
    paddingTop: theme.spacing(3),

    '&div': {
      width: 300,
    },

    '& button': {
      backgroundColor: 'transparent',
      color: '#fff',
      borderColor: theme.palette.secondary.main,
      textTransform: 'none',
      width: 150,
      height: 40,
      // borderRadius: 8,
    },

    '& .Mui-selected': {
      backgroundColor: theme.palette.secondary.main,
      '&:hover': {
        color: theme.palette.primary.main,
        background: theme.palette.secondary.main,
      },
      '&.MuiButton-contained.Mui-disabled': {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.secondary.main,
        opacity: 0.6,
      },
    },
  },
}))

enum AccountsPanel {
  clientAccounts = 'clientAccounts',
  sparlingAccounts = 'sparlingAccounts',
}

interface Props {
  classes?: {
    root?: string
    tabs?: string
    tabPanel?: string
  }
}

export const ToggleButtons: FC<Props> = (props) => {
  const [activePanel, setActivePanel] = React.useState<AccountsPanel>(AccountsPanel.clientAccounts)
  const classes = useStyles()

  const handleChange = useCallback((e) => {
    const panel = e.target.value
    setActivePanel(panel)
  }, [])

  return (
    <div className={clsx(classes.root, props.classes?.root)}>
      <Grid container>
        <ToggleButtonGroup value={activePanel} exclusive onChange={handleChange} className={classes.buttonsWrap}>
          <ToggleButton value={AccountsPanel.clientAccounts}>My Accounts</ToggleButton>
          <ToggleButton value={AccountsPanel.sparlingAccounts}>Sparling Accounts</ToggleButton>
        </ToggleButtonGroup>
      </Grid>

      <Grid container className={clsx(classes.tabPanel, props.classes?.tabPanel)}>
        {activePanel === AccountsPanel.clientAccounts && <ClientAccounts />}
        {activePanel === AccountsPanel.sparlingAccounts && <SparlingAccounts />}
      </Grid>
    </div>
  )
}
